module.exports = __webpack_public_path__ + "img/WordIcon256x256.5e396d38.png";